// extracted by mini-css-extract-plugin
export var modal = "_t8-0";
export var table = "_t8-1";